package article.spring

import androidx.compose.animation.AnimatedContent
import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.SizeTransform
import androidx.compose.animation.core.FiniteAnimationSpec
import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.spring
import androidx.compose.animation.core.tween
import androidx.compose.animation.expandVertically
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.shrinkVertically
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.animation.togetherWith
import androidx.compose.animation.with
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.requiredHeight
import androidx.compose.foundation.layout.requiredSize
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.IntSize
import androidx.compose.ui.unit.dp
import androidx.compose.ui.zIndex
import kotlin.math.exp


const val SPRING_EXPANDABLE_DRAWER =
    "9f872f897a0d3b60d715854f830f479e794c987fe81d9376aff9bed2b326ae0a"
const val TWEEN_EXPANDABLE_DRAWER =
    "0201ef6129994f1e5cdd1e3bdfcf8e7e55eb56f9118d06179cf5bcba59f477e6"

@Composable
fun SpringExpandableDrawer() {
    ExpandableDrawer(
        spring(
            stiffness = 85f
        ), spring(
            stiffness = 85f
        )

    )
}


@Composable
fun TweenExpandableDrawer() {
    ExpandableDrawer(
        tween(1_000),
        tween(1_000),
    )
}

@Composable
private fun ExpandableDrawer(
    animationSpecDp: FiniteAnimationSpec<Dp>,
    animationSpecIntSize: FiniteAnimationSpec<IntSize>
) {

    SpringGrid {
        var expanded by remember { mutableStateOf(false) }

        Column(
            modifier = Modifier
                .padding(16.dp)
                .fillMaxSize(),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Top,
        ) {


            SpringButton(
                onClick = {
                    expanded = !expanded
                }
            ) {
                Text(if (expanded) "Collapse" else "Expand", color = Color.Black)
            }

            val height by animateDpAsState(
                targetValue = if (expanded) 208.dp else 50.dp,
                animationSpec = animationSpecDp,
            )

            Column(
                Modifier
                    .fillMaxWidth(.5f)
                    .height(height)
                    .shadow(10.dp, RoundedCornerShape(10.dp))
                    .background(
                        color = Color.White,
                        shape = RoundedCornerShape(10.dp)
                    ),
                verticalArrangement = Arrangement.Top
            ) {
                Box(
                    Modifier
                        .height(50.dp)
                        .fillMaxWidth()
                        .zIndex(10f)
                        .background(Color.White)
                        .padding(vertical = 20.dp, horizontal = 32.dp)
                        .background(Color.Black.copy(alpha = .24f), RoundedCornerShape(4.dp))
                )
                Column(
                    Modifier
                        .requiredHeight(150.dp)
                        .fillMaxWidth()
                ) {
                    for (i in 1..3) {
                        Row(
                            Modifier.requiredHeight(50.dp)
                                .padding(horizontal = 24.dp),
                            verticalAlignment = Alignment.CenterVertically,
                        ) {
                            Box(
                                Modifier
                                    .fillMaxHeight()
                                    .padding(8.dp)
                                    .aspectRatio(1f)
                                    .background(Color.Black.copy(alpha = .12f), CircleShape)
                            )

                            Box(
                                Modifier
                                    .weight(1f, true)
                                    .padding(end = 8.dp)
                                    .height(4.dp)
                                    .background(Color.Black.copy(alpha = .12f), CircleShape)
                            )
                        }
                    }
                }
            }

        }
    }
}